import { render, staticRenderFns } from "./TabelaCoparticipacao.vue?vue&type=template&id=9ec78698&scoped=true&"
import script from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
export * from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaCoparticipacao.vue?vue&type=style&index=0&id=9ec78698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec78698",
  null
  
)

export default component.exports